import { socket } from './socket'
import { init, loadConnectedModels, unloadModel } from './scene'

document.addEventListener('DOMContentLoaded', function () {

  init()

  const submitButton = document.getElementById('submitConnexion')
  const inputRoom = Array.from(
    document.querySelectorAll(".chatbox-login-form input[name='room']")
  )
  const inputUsername = document.getElementById('usernameInput')
  let userRoom
  const avatars = ['Blue', 'Red', 'White', 'Yellow', 'Green', 'Purple']
  let avatarList = [
    ['n/A', 'n/A', 'n/A', 'n/A', 'n/A', 'n/A'],
    ['n/A', 'n/A', 'n/A', 'n/A', 'n/A', 'n/A'],
    ['n/A', 'n/A', 'n/A', 'n/A', 'n/A', 'n/A'],
    ['n/A', 'n/A', 'n/A', 'n/A', 'n/A', 'n/A'],
  ]
  let connectedUsers = []

  inputUsername.addEventListener('keyup', function (e) {
    toggleSubmitBtn()
  })

  inputRoom.forEach(function (input) {
    input.addEventListener('change', function (e) {
      toggleSubmitBtn()
    })
  })

  function toggleSubmitBtn() {
    const isValidRoom = inputRoom.some((input) => input.checked)
    const isValidUsername =
      inputUsername.value.length > 0 && inputUsername !== 'Anonymous'

    if (isValidRoom && isValidUsername) {
      submitButton.classList.remove('u-button--disabled')
    } else {
      submitButton.classList.add('u-button--disabled')
    }
  }

  submitButton.addEventListener('click', function (e) {
    e.preventDefault()
    submitButton.classList.remove('u-button--disabled')

    let inputRoom = document.querySelector(
      ".chatbox-login-form input[name='room']:checked"
    )
    let inputUsername = document.getElementById('usernameInput').value
    let userExist = false
    let roomList = [[], [], [], []]
    socket.emit('getUsers')
    socket.on('users', (users) => {

      users.forEach((user) => {
        if (getUsername(user.name) == inputUsername) {
          document.querySelector(
            '.chatbox-login__input+.u-input-errortext'
          ).innerText = 'Cet utilisateur existe déjà.'
          document
            .querySelector('.chatbox-login__input')
            .classList.add('u-input-error')
          userExist = true
          document
            .querySelector('.u-input-error')
            .addEventListener('input', function (e) {
              if (e.target.value != '') {
                e.target.classList.remove('u-input-error')
              }
            })
        }
        if (user.name.includes('/r')) {
          roomList[getRoomByUsername(user.name)].push(getUsername(user.name))
          avatarList[getRoomByUsername(user.name)][
            getSkinByUsername(user.name)
          ] = user.name
        }
      })
      if (!userExist) {
        // Initialiser la room :
        userRoom = inputRoom.value
        const userSkin = getFreeSkin(avatarList[userRoom])
        const username = `/r${userRoom}${userSkin}${inputUsername}`

        if (roomList[userRoom].length < 6) {
          socket.emit('leaveRoom', 'general')
          socket.emit('joinRoom', 'arrivants')

          roomList[userRoom].push(inputUsername)
          avatarList[userRoom][userSkin] = username
        } else {
          document.querySelector(
            '.chatbox-login__input+.u-input-errortext'
          ).innerText = 'Le camp est plein ! (6/6)'
          document
            .querySelector('.chatbox-login__input')
            .classList.add('u-input-error')
          document
            .querySelector('.u-input-error')
            .addEventListener('input', function (e) {
              if (e.target.value != '') {
                e.target.classList.remove('u-input-error')
              }
            })
          return false
        }
        socket.emit('setUsername', `/r${userRoom}${userSkin}${inputUsername}`)
        socket.emit('message', {
          value: `${inputUsername} s'est assis au campement ${
            parseInt(userRoom) + 1
          }.`,
          room: 'arrivants',
        })
        const room = `Camp${inputRoom.value}`
        document.querySelector('.chatbox-chat').setAttribute('data-room', room)
        socket.emit('joinRoom', room)
        document.querySelector('.chatbox-login-info h4').innerHTML =
          inputUsername
        document
          .querySelector('.chatbox-login-info img')
          .setAttribute('src', `./img/avatars/${avatars[userSkin]}.png`)
        document.querySelector('.chatbox-login').classList.add('chatbox-logged')

        loadConnectedModels(username, userRoom)
        users.forEach((user) => {
          if (user.name == 'Anonymous') {
            return false;
          }
          if (user.name != username) {
            pushUser(user)
          }
          if(user.name.includes("/r")) {
            loadConnectedModels(user.name, userRoom)
          }
        })
      } else {
        submitButton.classList.remove('u-button--disabled')
      }
    })
  })

  document
    .getElementById('submitMessage')
    .addEventListener('click', function (e) {
      sendMessage()
    })

    messageInput.addEventListener("keyup", function(e){
      if(e.key == 13 || e.key == "Enter") {
        sendMessage();
      }
    })

    function sendMessage() {
      const messageInput = document.getElementById('messageInput')
      if (messageInput.value !== '') {
        socket.emit('message', messageInput.value)
        socket.emit('message', {
          value: messageInput.value,
          room: document
            .querySelector('.chatbox-chat')
            .getAttribute('data-room'),
        })
        messageInput.value = ''
      }
    }

  scrollToBottom(document.querySelector(".chatbox-chat__message-container ul"));
  function scrollToBottom(element) {
      setTimeout(() => {
          element.scrollTop = element.scrollHeight;
      }, 1);
  }

  function pushUser(user) {
    if (
      socket.id == user.id ||
      document.querySelector(`li[data-userid="${user.id}"]`) != null ||
      getRoomByUsername(user.name) != userRoom
    ) {
      return false
    }
    connectedUsers.push(user)
    loadConnectedModels(user.name, userRoom) 
    document.querySelector('.chatbox-users-list ul').innerHTML += `
      <li class="u-username" data-userid='${user.id}'>
        <img class="u-username__avatar" src="./img/avatars/${
          avatars[getSkinByUsername(user.name)]
        }.png" alt="">
        <div>
        <h4>${getUsername(user.name)}</h4>
        <p>Connecté</p>
      </li>`;
    document
      .querySelector(`li[data-userid="${user.id}"]`)
      .animate(
        [{ transform: 'translateX(31rem)' }, { transform: 'translateX(0px)' }],
        1000
      )
  }

  function getFreeSkin(skinArray) {
    for (let i = 0; i < skinArray.length; i++) {
      if (skinArray[i] == 'n/A') {
        return i
      }
    }
  }
  function getUsername(username) {
    return username.substring(4)
  }

  function displayMessage(msg) {
    if(msg.room === "general") {return;} 
    const timestamp = msg.time

    const date = new Date(timestamp)
    const hour = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours()
    const minutes =
      date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes()
    const formattedTime = hour + 'h' + minutes

    const ownedClass = msg.user.id == socket.id ? ' u-message-owned' : ''
    document.querySelector('.chatbox-chat__message-container ul').innerHTML += `
    <li class="u-message${ownedClass}">
      <div class="u-message__header">
        <h4><span class="u-message__username">${getUsername(msg.user.name)}</span>
        <span class="u-message__time"> ${formattedTime}</span></h4>
      </div>
      <p class="u-message__content">
        ${msg.value}
      </p>
    </li>
    `
    scrollToBottom(
      document.querySelector('.chatbox-chat__message-container ul')
    )
  }

  socket.on('message', (message) => {
    displayMessage(message)
  })
  socket.on('updateUsername', (user) => {
    pushUser(user)
  })
  socket.on('userDisconnection', (user) => {
    const listItem = document.querySelector(`li[data-userid="${user.id}"]`)
    if (listItem != null) {
      const username = listItem.querySelector('h4').innerText
      
      socket.emit('message', {
        value: `${username} est parti du campement ${
          parseInt(userRoom) + 1
        }.`,
        room: 'arrivants',
      })

      listItem.classList.add('u-username--disconnected')
      setTimeout(() => {
        listItem.remove()
      }, 1000)

      if (username == 'Anonymous') {
        return false
      }
      const indexUnconnected = connectedUsers.findIndex((userItem) => {
        return user.id === userItem.id
      })
      const disconnectedUsername = connectedUsers[indexUnconnected].name;
      unloadModel(connectedUsers.filter((e) => e.id == user.id)[0]?.name);
      avatarList[getRoomByUsername(disconnectedUsername)][
        getSkinByUsername(disconnectedUsername)
      ] = 'n/A'
      connectedUsers.splice(indexUnconnected, 1)
    }
  })
})

export function getRoomByUsername(username) {
  if(!username.includes("/r")) {return "general";}
  return username.slice(2, 3)
}
export function getSkinByUsername(username) {
  if(!username.includes("/r")) {return "n/A";}
  return username.slice(3, 4)
}